const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class BillingService {
  static async saveCertificates(certificateData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/billing/certificates`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(certificateData)
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('Error saving certificates:', error);
      throw error;
    }
  }

  static async setDefaultCertificate(certificateId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/billing/certificates/default`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ certificateId })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('Error setting default certificate:', error);
      throw error;
    }
  }
}

export default BillingService;
